<template>
  <div class="foot-container">
    <div class="center">
      <div class="call inlinediv">
        <img :src="callimg" alt="" />
        <div class="callright inlinediv">
          <div class="title">服务热线</div>
          <div class="tel">0755-27651888<br />转6218</div>
        </div>
      </div>
      <div class="law inlinediv">
        <div class="title">法律政策</div>
        <div>
          <router-link to="/home/legalNotices" class="as">法律声明</router-link>
        </div>
        <!-- <div>
                    <router-link to="/home/service" class="as">服务条款</router-link>
                </div>
                <div>
                    <router-link to="/home/privacy" class="as">隐私政策</router-link>
                </div> -->
      </div>
      <div class="about inlinediv">
        <div class="title">关于我们</div>
        <div>
          <router-link to="/about" class="as">公司简介</router-link>
        </div>
      </div>
      <div class="contact inlinediv">
        <div class="title">联系我们</div>
        <div class="text">工作日：上午08：30-12：00 下午13：30-18：00</div>
        <div class="text">邮箱：T-Smart@topband.com.cn</div>
        <div class="text">
          联系地址：深圳市宝安区石岩塘头大道梨园工业区拓工业园
        </div>
      </div>
      <div class="public inlinediv">
        <div class="title">关注公众号</div>
        <img :src="qrimg" alt="" />
      </div>
    </div>
    <div class="line"></div>
    <div class="bottom">
      <!-- 粤ICP备17154945号 Copyright©深圳市拓邦软件技术有限公司 -->
      <a
        class="topband-link"
        href="http://beian.miit.gov.cn"
        target="_blank"
        ><span
          class="topband-report-link-text"
          data-spm-anchor-id="5176.15218677.J_9220772140.i3.7c6265ddnpgmJR"
          >粤ICP备17154945号 Copyright©深圳市拓邦软件技术有限公司</span
        ></a
      >
      <a
        class="topband-link"
        href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030602005379"
        target="_blank"
        ><img
          class="topband-report-img"
          :src="TBimg"
        /><span
          class="topband-report-link-text"
          data-spm-anchor-id="5176.15218677.J_9220772140.i3.7c6265ddnpgmJR"
          >粤公网安备 44030602005379号</span
        ></a
      >
    </div>
  </div>
</template>
<script>
import callImg from '@/assets/images/bottom_servicehotline_icon.png'
import qrImg from '@/assets/images/bottom_QRcode.png'
import TBimg from '@/assets/images/TB40-40.png'
export default {
  watch: {},
  components: {},
  data() {
    return {
      callimg: callImg,
      qrimg: qrImg,
      TBimg: TBimg
    }
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    goBeian() {
      window.open('http://www.beian.miit.gov.cn')
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss">
@import '~styles/index.scss';
.foot-container {
  color: #ffffff;
  font-family: MicrosoftYaHei-Bold;
  font-weight: normal;
  font-stretch: normal;
  line-height: vw(36);
  letter-spacing: 0px;
  text-align: left;
  min-width: vw(1200);
  width: 100%;
  height: vw(290);
  background-color: #242730;

  .center {
    text-align: center;
    margin: 0 auto;
    min-width: vw(1200);
    height: vw(237);

    .title {
      font-size: vw(16);
      text-align: left;
    }

    .inlinediv {
      display: inline-block;
    }

    a {
      text-decoration: none;
      color: #999999;
    }

    .call {
      margin-left: vw(22);
      margin-top: vw(42);
      // float: left;
      vertical-align: top;
      .callright {
        margin-left: vw(25);

        .tel {
          text-align: left;
          font-size: vw(30);
        }
      }
    }

    .law {
      margin-top: vw(42);
      // float: left;
      vertical-align: top;
      margin-left: vw(96);
    }

    .about {
      margin-top: vw(42);
      // float: left;
      vertical-align: top;
      margin-left: vw(63);
    }

    .contact {
      margin-top: vw(42);
      // float: left;
      vertical-align: top;
      margin-left: vw(65);

      .text {
        text-align: left;
        color: #999999;
      }
    }

    .public {
      margin-top: vw(42);
      // float: left;
      vertical-align: top;
      margin-left: vw(54);
    }
  }

  .line {
    text-align: center;
    margin: 0 auto;
    width: vw(1200);
    height: 1px;
    background-color: #ffffff;
    opacity: 0.2;
  }

  .bottom {
    text-align: center;
    margin: 0 auto;
    color: #999999;
    cursor: pointer;
    .topband-link {
      display: inline-block;
      text-decoration: none;
      .topband-report-img {
        width: 20px;
        display: inline-block;
        height: 20px;
        margin-right: 12px;
        vertical-align: middle;
        margin-left: 15px;
      }
      .topband-report-link-text {
        height: 20px;
        line-height: 20px;
        color: #939393;
        margin-left: -7px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footbar.vue